import { useCallback } from "react";
import { generateMockMatterFilePayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterFile } from "@/lib/data/react-query/matters/matter-file";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterFile = () => {
  const createFile = useCreateMatterFile();

  const createMockMatterFile = useCallback(
    async (
      matterId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createFile.mutateAsync(
          generateMockMatterFilePayload(matterId, overrides),
        ),
      ),
    [createFile],
  );

  return {
    createMockMatterFile,
    mutation: createFile,
  };
};
